import { httpService } from '../..';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { IInventoryItem, IInventoryRequest } from './inventoryInterfaces';

export async function fetchInventory(
  request: IInventoryRequest[]
): Promise<IApiExecuteRespone<Record<string, IInventoryItem>>> {
  const response: IApiExecuteRespone<Record<string, IInventoryItem>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.inventoryQuery(), request);
    response.value = await apiResponse.json();
  } catch (e) {
    response.exception = e;
    response.requestFailed = true;
  }

  return response;
}
